import { ModalViewSliceShape, modalViewReducerPath } from './slice';

export const modalViewIsAnyOpenedSelector = (state: ModalViewSliceShape) => Object.keys(state[modalViewReducerPath].openedViews).length > 0;
